
import { defineComponent } from 'vue'
import KanbanAddForm from '@/components/KanbanAddForm.vue'
import { createTaskService } from '@/services/task'
import { FormActions } from 'vee-validate'
export default defineComponent({
  props: {
    listId: {
      type: String,
      required: true
    }
  },
  inject: ['addTaskToList', 'setToast'],
  data () {
    return {
      showInput: false
    }
  },
  components: {
    KanbanAddForm
  },
  methods: {
    async handleAddTask (value: string, values: unknown, actions: FormActions<Record<string, unknown>>) {
      try {
        const res = await createTaskService(this.$route.params.boardId, this.listId, { task: value })
        if (!res.error) {
          this.showInput = false
          this.addTaskToList(res.data)
        }
      } catch (error) {
        actions.setFieldError('input', error.task.msg)
      }
    }
  }
})
